'use client'

import React, { useState, useEffect, useRef } from 'react'
import styled, { css, ThemeProvider } from 'styled-components'
import { calendarPalette as palette, isCasinoTheme } from '../calendar-stuff/CalendarPalette';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import HamburgerIcon from './HamburgerIcon';
import gsap from 'gsap';
import { Link, useRouter } from '../../navigation';
// import { useRouter } from 'next/navigation';
import { usePathname } from 'next/navigation'
import { isCasinoRoute } from '@/utils/casinoTheme.mjs';
import { canManageReservations } from '@/utils/reservationAccess.mjs';
import { useGlobalContext } from '@/context/context';
import { useTranslations } from 'next-intl';

const MenuPanel = styled.div`
    z-index: 285;
    position: fixed;
    top: 0;
    width: 16rem;
    background-color: ${({ theme }) => theme.calendarCasino ? palette.menuBackground : '#cbc8b7ff'};
    border-right: 1px solid ${({ theme }) => theme.calendarCasino ? palette.accentBorder : 'black'};
    box-shadow: ${({ theme }) => theme.calendarCasino ? '8px 0 28px #30231d26' : '4px 4px 4px rgba(0,0,0,.1)'};
    color: ${({ theme }) => theme.calendarCasino ? palette.onDark : 'inherit'};
    /* background-color: #b4b09cff; */
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    overflow-y: auto;
    overscroll-behavior: contain;
    transform: translateX(-100%);
    gap: 1rem;
    padding: 0 1rem;
    > * { flex-shrink: 0; }
    .menu-brand {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 auto;
        padding: 36px 0 0;
    }
    p {
        font-size: 1.3rem;
        font-weight: 500;
        cursor: pointer;
        &:hover {
            font-weight: 600;
        }
    }
    p:hover {
        /* font-style: italic; */
        /* text-decoration: underline; */
        /* color: white; */
        color: ${({ theme }) => theme.calendarCasino ? palette.menuHighlight : 'inherit'};
    }
    ${({ theme }) => theme.calendarCasino && css`
        .menu-brand a {
            display: inline-flex;
            border-radius: 4px;
            &:focus-visible { outline: 2px solid ${palette.gold}; outline-offset: 6px; }
        }
        .menu-brand img {
            width: 128px;
            height: auto;
            filter: brightness(0) invert(1);
        }
        p { transition: color .15s ease; }
        > p { color: ${palette.menuHighlight}; }
        h3 { color: ${palette.menuHighlight}; }
    `}
`

const AdminPortalDiv = styled.div`
    margin-top: 1.3rem;
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 1.3rem;
    h3 {
        font-weight: 800;
        font-size: 1.3rem;
        margin-bottom: .5rem;
    }
    p {
        font-size: 1.2rem;
    }
`

const MenuIdentity = styled.dl`
    width: 100%;
    padding: 0 8px 28px;
    margin: 0;
    border-bottom: 1px solid ${({ theme }) => theme.calendarCasino ? '#ecd6a735' : palette.border};
    text-align: center;
    line-height: 1.5;
    .identity-label { font-size: .65rem; font-weight: 600; letter-spacing: .12em; text-transform: uppercase;
      color: ${({ theme }) => theme.calendarCasino ? palette.menuHighlight : palette.muted}; }
    .identity-name { margin: 3px 0 8px; font-size: 1.1rem; font-weight: 600; overflow-wrap: anywhere; }
    .identity-role { display: inline-block; max-width: 100%; margin: 0; padding: 2px 12px; border-radius: 999px;
      border: 1px solid ${({ theme }) => theme.calendarCasino ? '#ecd6a74d' : palette.border};
      background: ${({ theme }) => theme.calendarCasino ? '#ffffff08' : palette.surface}; font-size: .75rem; overflow-wrap: anywhere; }
`;

const LogoutBtn = styled.button`
    border: 1px solid ${({ theme }) => theme.calendarCasino ? palette.accentBorder : 'black'};
    width: fit-content;
    margin: 0 auto;
    padding: .7rem 2.25rem;
    margin-bottom: 1rem;   
    border-radius: 5px; 
    font-size: 1.1rem;
    font-weight: 600;
    &:hover {
        /* text-decoration: underline; */
        background: ${({ theme }) => theme.calendarCasino ? '#ffffff12' : 'transparent'};
    }
`


function Menu() {
    const { setMenuLoading, setUsersBooked, setActiveDay, setOtherSide, admin, logout } = useGlobalContext();
    const router = useRouter();
    const menuRef = useRef(null);
    const [menuActive, setMenuActive] = useState(false);
    const pathname = usePathname();
    const calendarCasino = isCasinoTheme && isCasinoRoute(pathname);
    const showHome = ['admin', 'hotel', 'casino'].includes(admin?.adminRole);
    const showAdminPortal = canManageReservations(admin) || admin?.adminRole === 'casino'
        || (admin?.adminRole === 'hotel' && admin.viewRecords == true);
    const tMenu = useTranslations('Menu');

    useEffect(() => {
        if (!menuRef.current) return;
        if (menuActive) {
            gsap.to(menuRef.current, {
                transform: 'translateX(0%)',
                duration: 0.5,
                ease: 'power3.inOut',
                onStart: () => {
                    menuRef.current.style.display = 'flex'
                }
            });
        }
        if (!menuActive) {
            gsap.to(menuRef.current, {
                transform: 'translateX(-100%)',
                duration: 0.5,
                ease: 'power3.inOut',
                onComplete: () => {
                    if (menuRef.current !== null) {
                        // menuRef.current.style.display = 'none'
                    }
                }
            });
        }
    }, [menuActive])


    useEffect(() => {
        setMenuLoading(false);
        setMenuActive(false);
        if (pathname !== '/calendar') {
            setOtherSide(false);
            setUsersBooked([]); 
            setActiveDay('');
        }
      }, [pathname]);
      

    const handleCalendarPage = () => {
        // setOtherSide(false);
        router.push('/calendar');
    }
    const handleAddUserPage = () => {
        // setOtherSide(false);
        router.push('/admin/add-client');
    }
    const handleViewUsersPage = () => {
        // setOtherSide(false);
        router.push('/admin/view-clients');
    }
    const handleGeneratePeriodPage = () => {
        // setOtherSide(false);
        router.push('/admin/generate-period');
    }
    const handleUploadCSVPage = () => {
        // setOtherSide(false);
        router.push('/admin/upload-csv');
    }
    const handleViewRecordsPage = () => {
        // setOtherSide(false);
        router.push('/admin/view-records');
    }
    const handleEmailsPage = () => {
        // setOtherSide(false);
        router.push('/admin/share-emails');
    }
    const handleAdminControlPage = () => {
        // setOtherSide(false);
        router.push('/admin/admin-control');
    }
    const handleReservationsPage = () => {
        // setOtherSide(false);
        router.push('/admin/reservations');
    }
    const handleDeletePeriodPage = () => {
        // setOtherSide(false);
        router.push('/admin/delete-period');
    }

  return (
    <ThemeProvider theme={{ calendarCasino }}>
    {pathname !== '/' && (
        <>
        {admin && (
            <>
        <HamburgerIcon menuActive={menuActive} setMenuActive={setMenuActive} />
        <MenuPanel ref={menuRef}>
            <div className="menu-brand">
                {calendarCasino && (
                    <Link href="/calendar" aria-label={tMenu('Home')} onClick={() => setMenuActive(false)}>
                        <img src="/img/greyrock-eagle.png" alt="Grey Rock Casino" width="404" height="249" />
                    </Link>
                )}
            </div>
            <MenuIdentity>
                <dt className="identity-label">{tMenu('SignedInAs')}</dt><dd className="identity-name">{admin.name}</dd>
                <dt className="sr-only">{tMenu('Role')}</dt><dd className="identity-role">{['admin', 'hotel', 'events', 'grat', 'casino'].includes(admin.adminRole)
                    ? tMenu(`Roles.${admin.adminRole}`) : admin.adminRole}</dd>
            </MenuIdentity>
            {showHome && <p onClick={(e) => handleCalendarPage()}>{tMenu('Home')}</p>}
            {/* <p onClick={(e) => handleProfilePage()}>Profile</p> */}
            {showAdminPortal && <AdminPortalDiv>
                <h3>{tMenu('AdminPortal')}</h3>
                {admin && (admin.adminRole === 'hotel' && admin.viewRecords == true) && (
                    <p onClick={(e) => handleViewRecordsPage()}>{tMenu('ViewRecords')}</p>
                )}
                {(admin && (admin.adminRole === 'casino' || admin.adminRole === 'admin')) && (
                    <>
                    <p onClick={(e) => handleAddUserPage()}>{tMenu('AddClient')}</p>
                    <p onClick={(e) => handleViewUsersPage()}>{tMenu('ViewEditPromoCodes')}</p>
                    </>
                )}
                {(admin && admin.adminRole === 'admin') && (
                    <>
                    {/* <p onClick={(e) => handleGeneratePeriodPage()}>Generate period</p> */}
                    <p onClick={(e) => handleUploadCSVPage()}>{tMenu('UploadCSV')}</p>
                    <p onClick={(e) => handleViewRecordsPage()}>{tMenu('ViewRecords')}</p>
                    <p onClick={(e) => handleEmailsPage()}>{tMenu('SetEmails')}</p>
                    <p onClick={(e) => handleDeletePeriodPage()}>{tMenu('DeletePeriod')}</p>
                    </>
                )}
                {canManageReservations(admin) && (
                    <p onClick={(e) => handleReservationsPage()}>{tMenu('HandleReservations')}</p>
                )}
                {admin?.adminRole === 'admin' && (
                    <p onClick={(e) => handleAdminControlPage()}>{tMenu('AdminControl')}</p>
                )}
            </AdminPortalDiv>}
            <div style={{flexGrow: 1}}></div>
            <LogoutBtn type="button" onClick={logout}>{tMenu('Logout')}</LogoutBtn>
        </MenuPanel>
        </>
        )}
        </>
    )}
    </ThemeProvider>
  )
}

export default Menu
